import _ from "lodash";

import FileUpload from "./FileUpload";
import EventEmitter from "eventemitter3";
import API from "../service/API";

const MAX_CONCURRENT_UPLOADS = 2;
const MAX_CONCURRENT_JOBS = 2;

class UploadManager extends EventEmitter {
  constructor() {
    super();

    this.files = {};

    this.needsId = [];
    this.gettingIds = {};
    this.needsUploading = [];
    this.uploading = {};
    this.errors = {};
    this.activeJobs = 0;

    this.isUploading = false;
  }

  uploadAssetFile(asset, file) {
    var fileInfo = _.pick(asset, ["id", "height", "width", "folder_id"]);
    fileInfo.file = file;

    var upload = new FileUpload(fileInfo, API);
    this.files[upload.id] = upload;
    this.needsId.push(upload);

    this._checkFiles();
  }

  _attachListeners(upload) {
    upload.on("error", this._uploadError, this);
    upload.on("complete", this._uploadComplete, this);
    upload.on("progress", this._uploadProgress, this);
    upload.on("asset", this._receivedAsset, this);
  }

  _checkFiles() {
    if (this.activeJobs <= MAX_CONCURRENT_JOBS) {
      if (this.needsId.length > 0) {
        this._getAssetId();
      } else if (this.needsUploading.length > 0) {
        this._startUpload();
      }
    }

    this._checkUploading();
  }

  _getAssetId() {
    var upload = this.needsId.pop();
    this._attachListeners(upload);
    this.gettingIds[upload.id] = upload;
    upload.start();
    this.activeJobs++;
  }

  _startUpload() {
    var upload = this.needsUploading.pop();
    this.uploading[upload.id] = upload;
    upload.upload();
    this.activeJobs++;
  }

  _uploadError(err, upload) {
    delete this.uploading[upload.id];
    delete this.gettingIds[upload.id];
    delete this.files[upload.id];
    this._completeJob();

    this._cleanupFileUpload(upload);
    this.errors[upload.id] = upload;

    this.emit("error", { error: err, id: upload.id });

    this._checkFiles();
  }

  _uploadComplete(upload) {
    delete this.uploading[upload.id];
    delete this.files[upload.id];
    this._cleanupFileUpload(upload);
    this._completeJob();

    this.emit("complete", { id: upload.id, error: upload.error, completeData: upload.completeData });

    this._checkFiles();
  }

  _receivedAsset(asset, upload) {
    delete this.gettingIds[upload.id];
    this.needsUploading.push(upload);
    this._completeJob();

    this.emit("asset", { asset: asset, id: upload.id });

    this._checkFiles();
  }

  _uploadProgress(percent, upload) {
    this.emit("progress", { percent: percent, id: upload.id });
  }

  _cleanupFileUpload(upload) {
    upload.destroy();
    upload.removeAllListeners();
  }

  _checkUploading() {
    var isUploading = _.size(this.files) > 0;
    if (isUploading != this.isUploading) {
      this.emit("statusChange", isUploading);
    }
    this.isUploading = isUploading;
  }

  _completeJob() {
    this.activeJobs = Math.max(0, this.activeJobs - 1);
  }

  reset() {}
}

export default new UploadManager();
